// Vendors
import $ from 'jquery';
import 'jquery.localscroll/jquery.localScroll.min';

$(document).ready(() => {
  const scrollParameters = {
    hash: true,
    duration: 500,
    easing: 'swing',
    offset: { top: getScrollOffset() }
  };
  let timer = '';

  // Check if there any any PDF embeds present on the page.
  if ($('.pdfemb-viewer').length) {
    // Block browser-native scroll first.
    if (location.hash) {
      setTimeout(() => window.scrollTo(0, 0), 1);
      timer = setInterval(scrollAfterAllPDFEmbedsLoaded, 750);
    }
  } else {
    $.localScroll(scrollParameters);
  }

  function scrollAfterAllPDFEmbedsLoaded() {
    let allLoaded = false;

    $('.pdfemb-viewer').each((index, element) => {
      const thisHeight = $(element).height();
      allLoaded = thisHeight > 100 ? true : false;
    });

    if (allLoaded) {
      $.localScroll(scrollParameters);
      clearInterval(timer);
    }
  }

  function getScrollOffset() {
    let offset = -70;

    if (document.body.offsetWidth > 768) offset = -110;
    if (document.body.offsetWidth > 1040) offset = -160;

    return offset;
  }
});

if ($('.mega-menu-overlay').length) {
  const overlay = $('.mega-menu-overlay');

  $(
    '.nav-primary__submenu, .nav-primary .submenu, .nav-primary .primary-item-link'
  ).on('mouseover', (event) => {
    overlay.addClass('nav-primary--open');
  });

  // Toggle Off
  $('.nav-primary__link').on('mouseleave', (event) => {
    overlay.removeClass('nav-primary--open');
  });

  $(
    '.nav-primary__submenu, .nav-primary .submenu, .nav-primary .primary-item-link'
  ).on('mouseleave', (event) => {
    overlay.removeClass('nav-primary--open');
  });
}
